import React, { useContext } from "react";
import { DataContext } from "../../context/DataContext";
import Pagination from "../CaseStudy/Pagination";
import BlogsList from "./BlogsList";
import HeroSection from "./HeroSection";

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const BlogPage = ({ setIsOpen }: Props) => {
  const dataContext = useContext(DataContext);

  return (
    <div className="flex flex-col overflow-hidden mx-auto max-w-screen-2xl items-center justify-center">
      <HeroSection setIsOpen={setIsOpen} />
      <BlogsList />
      <Pagination
        totalPages={dataContext.totalBlogPages}
        currentPage={dataContext.currentBlogPage}
        onPageChange={dataContext.handleBlogPageChange}
      />
    </div>
  );
};

export default BlogPage;
